<template>
     <div class="task-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Tasks" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="task-id" type="hidden" v-model="task.id" />
              <b-row>
                <b-col md="12" sm="12">
                     <b-form-radio-group
                        v-model="task.type_task_id_task"
                        :options="typetasks"
                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        ></b-form-radio-group>
                </b-col>
              </b-row>
             <b-row>
                <b-col md="12" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="task-description_task">
                        <b-form-input 
                            id="task-description_task" 
                            type="text" 
                            ref="searchFocus"
                            v-model="task.description_task" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Descrition Task..." />
                    </b-form-group>
                </b-col>                 
             </b-row>
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Date:"
                    label-for="task-task_date"
                    >
                    <b-form-input
                    id="task-task_date"
                    type="date"
                    v-model="task.task_date"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Start:"
                    label-for="task-start_date_task"
                    >
                    <b-form-input
                    id="task-start_date_task"
                    type="time"
                    v-model="task.start_date_task"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="End:"
                    label-for="task-end_date_task"
                    >
                    <b-form-input
                    id="task-end_date_task"
                    type="time"
                    v-model="task.end_date_task"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row v-if="task.type_task_id_task === 2">
                <b-col md="6" sm="12">
                     <b-form-group 
                        label="Send Email for:" 
                        label-for="task-send_email_for_task">
                        <b-form-input 
                            id="task-send_email_for_task" 
                            type="text" 
                            ref="searchFocus"
                            v-model="task.send_email_for_task" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Send Email for..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                     <b-form-group 
                        label="Email:" 
                        label-for="task-email_for_task">
                        <b-form-input 
                            id="task-email_for_task" 
                            type="text" 
                
                            v-model="task.email_for_task" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Email..." />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row v-if="task.type_task_id_task === 1">
                 <b-col md="6" sm="12">
                     <b-form-group 
                        label="Meet with:" 
                        label-for="task-meet_with_task">
                        <b-form-input 
                            id="task-meet_with_task" 
                            type="text" 
                
                            v-model="task.meet_with_task" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Meet with..." />
                    </b-form-group>
                </b-col>
             </b-row>   
            <b-card class="owner-search-card">
                    <b-tabs card vertical >
                     <b-tab title="User Shared" active> 
                        <b-row>
                        <b-button  
                            title="Add User" 
                            size="sm" 
                            class="mb-2 fa fa-plus" 
                            variant="dark" 
                            v-if="task.id > 0"
                            @click="openModalShared">
                        </b-button>
                        </b-row>
                        <b-row>
                              <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="taskshareds" 
                            :fields="fieldShared">
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteShared(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>  
                        </b-row>
                        
                        </b-tab>
                    </b-tabs>
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadTasks(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="6" sm="12">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by description" 
                            class="form-control">
                    </div>
                 </b-col>
            </b-row>    
              <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Date:"
                    label-for="task-start_date"
                    >
                    <b-form-input
                    id="task-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Date:"
                    label-for="task-end_date"
                    >
                    <b-form-input
                    id="task-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Type Task">
                    <b-form-radio-group
                        size="lg"
                        v-model="type_task_id_task"
                        @input="loadTasks"
                        :options="typetasks"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                    ></b-form-radio-group>  
                    </b-form-group>    
                </b-col>
             </b-row>  
        <b-row>   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="desc_type_task_id">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.scheduled_task"
                        title = "Scheduled" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxScheduled(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>  
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadTask(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadTask(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadTask(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
        <b-modal
            id="modalShared"
            ref="modal"
            title-tag="h6"
            title="User Sharead"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveShared"
        >
            <b-form>
                <b-col md="12" sm="12">
                    <b-form-group 
                        label="User:" 
                        label-for="taskshared-user_id_shared">
                        <b-select 
                            id="taskshared-user_id_shared"
                            size="sm"
                            :options="users" 
                            v-model="taskshared.user_id_shared" 
                            />
                    </b-form-group>
                </b-col> 
            </b-form>
        </b-modal>
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'TaskSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                task: {},
                taskshared: {},
                taskshareds:[],
                typetasks:[],
                tasks: [],
                users: [],
                perPage: 50,
                currentPage: 1,
                start_date:null,
                end_date:null,
                scheduled_task: null,
                type_task_id_task: null,
                desc_type_task_id: [],
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'description_type_task', label: 'Type', sortable: true,variant: 'light' },
                { key: 'description_task', label: 'Description', sortable: true,variant: 'light' },
                 { key: 'task_date',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                },
                { key: 'start_date_task',label: 'Start',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'end_date_task',label: 'End',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'scheduled_task', label: 'Scheduled', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'}, 
                { key: 'finished_task', label: 'Finished', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},                              
                { key: 'actions', label: 'Action',variant: 'light' },

                ],
                fieldsEmail: [
                { key: 'description_type_task', label: 'Type', sortable: true,variant: 'light' },
                { key: 'description_task', label: 'Description', sortable: true,variant: 'light' },
                { key: 'send_email_for_task', label: 'Send E-mail for', sortable: true,variant: 'light' },
                { key: 'email_for_task', label: 'E-mail', sortable: true,variant: 'light' },
                 { key: 'task_date',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                },
                 { key: 'start_date_task',label: 'Start',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'end_date_task',label: 'End',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'scheduled_task', label: 'Scheduled', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'}, 
                { key: 'finished_task', label: 'Finished', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},                              
                { key: 'actions', label: 'Action',variant: 'light' },

                ],
                 fieldsMeet: [
                { key: 'description_type_task', label: 'Type', sortable: true,variant: 'light' },
                { key: 'description_task', label: 'Description', sortable: true,variant: 'light' },
                { key: 'meet_with_task', label: 'Meet with', sortable: true,variant: 'light' },
                 { key: 'task_date',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                },
                { key: 'start_date_task',label: 'Start',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'end_date_task',label: 'End',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'scheduled_task', label: 'Scheduled', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'}, 
                { key: 'finished_task', label: 'Finished', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},                              
                { key: 'actions', label: 'Action',variant: 'light' },

                ],
                fieldShared: [
                { key: 'name', label: 'User', sortable: false ,variant: 'light'},   
                { key: 'actions', label: 'Action',variant: 'light' }
                ],
               
            }
        },
        computed: {
            filteredList() {
                return this.tasks.filter(task => {
                    return task.description_task.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.tasks.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            async showMsgBoxScheduled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to scheduled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.scheduled(item)
                    }
                })
            },
            async showMsgBoxDeleteShared(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeShared(item)
                    }
                })
            },
            loadTasks(){

                if(this.type_task_id_task === 1){
                     this.desc_type_task_id = this.fieldsMeet
                }else if(this.type_task_id_task === 2){
                      this.desc_type_task_id = this.fieldsEmail
                }
                else{
                     this.desc_type_task_id = this.fields
                }
               

                const url = `${baseApiUrl}/tasksbycompany/${this.compan.id}?start_date=${this.start_date}&end_date=${this.end_date}&type_task_id_task=${this.type_task_id_task}`
                axios(url).then(res =>{
                     this.tasks = res.data
                      this.isBusy = false
                })
            },
            loadTaskShareds(){
                const url = `${baseApiUrl}/tasksharedbytasks/${this.task.id}`
                axios(url).then(res =>{
                     this.taskshareds = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.task = {}
                    this.taskshared = {}
                    this.taskshareds = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadTasks()
                this.taskshareds = []
                this.task = {}
            },
            async save() {

                const method = this.task.id ? 'put' : 'post'
                const id = this.task.id ? `/${this.task.id}` : ''

               
                this.task.user_id_task = this.user.id
                this.task.company_id_task = this.compan.id
                

                await axios[method](`${baseApiUrl}/tasks${id}`, this.task)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            async saveShared() {
      
                    const method = this.taskshared.id ? 'put' : 'post'
                    const id = this.taskshared.id ? `/${this.taskshared.id}` : ''
                    this.taskshared.task_id_shared = this.task.id
                    await axios[method](
                        `${baseApiUrl}/taskshareds${id}`,
                        this.taskshared
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.taskshared = {}
                            this.loadTaskShareds()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.task.id
                    axios.delete(`${baseApiUrl}/tasks/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeShared(item) {
                     axios.delete(`${baseApiUrl}/taskshareds/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTaskShareds()
                        })
                        .catch(showError)
            },
            loadTask(task, mode = 'save') {
                this.mode = mode
                if(task.date_open_service) task.date_open_service = this.formatDate(task.date_open_service)
                 if(task.start_date_task) task.start_date_task = moment(task.start_date_task).format("HH:mm")
                 if(task.end_date_task) task.end_date_task = moment(task.end_date_task).format("HH:mm")

                this.task = { ...task }
                this.$refs.searchFocus.focus();
                this.loadTaskShareds()
                
            },
            loadTaskShared(item){
                this.taskshared = {...item}
            },
            openModalShared() {
                this.$bvModal.show('modalShared')
            },
            loadUsers() {
                const url = `${baseApiUrl}/usersbycompanyadmin/${this.compan.id}`
                axios.get(url).then(res => {
                    this.users = res.data.map(type => {
                        return { value: type.id, text: type.name }
                    })
                })
            },
            loadTypeTasks() {
                const url = `${baseApiUrl}/typetasks`
                axios.get(url).then(res => {
                    this.typetasks = res.data
                })
            },
            async scheduled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/scheduledtasks/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTasks()

                        })
                        .catch(showError)

           },


        },
        mounted(){

                this.start_date = moment().format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadTasks()
            this.loadTypeTasks()
            this.loadUsers()
            this.showTable = true
            this.desc_type_task_id = this.fields
        }
}
</script>

<style>


    .task-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .task-search button{
        font-size: 0.75rem;
    }

     .task-search select{
        font-size: 0.75rem;
    }

    .task-search input{
        font-size: 0.75rem;
    }


    .task-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    #modalShared {
        font-size: 0.75rem;
    }

    #modalShared button{
        font-size: 0.75rem;
    }

       #modalShared select{
        font-size: 0.75rem;
    }

     #modalShared input{
        font-size: 0.75rem;
    }

      #modalShared label{
        font-size: 0.75rem;
        color: black;
    }

 

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
